// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerComplaint_Page__2eYWb","FilterInput":"ManagerComplaint_FilterInput__PCiin"};